<template>
  <div class="present-view">
    <ScreenBg>
      <div class="content">
        <Title>
          <h1>Derzeit sind im</h1>
          <h1>KISI Haus</h1>
        </Title>
        <SlidingList
          :persons="$store.getters.presentPersons"
          v-slot="{ person }"
        >
          <Person :person="person" :key="person.id" />
        </SlidingList>
      </div>
    </ScreenBg>
    <div class="sidebar-image-container">
      <img class="sidebar-image" src="@/assets/img/Maria.png" />
    </div>
  </div>
</template>

<script>
import ScreenBg from '@/components/ScreenBg.vue';
import SlidingList from '@/components/person-list/SlidingList.vue';
import Person from '@/components/person-list/Person.vue';
import Title from '@/components/Title.vue';

export default {
  name: 'PresentView',
  components: {
    ScreenBg,
    Title,
    SlidingList,
    Person,
  },
};
</script>
